import { render, staticRenderFns } from "./PerformanceTargetResultCard.vue?vue&type=template&id=3b50e86b"
import script from "./PerformanceTargetResultCard.vue?vue&type=script&lang=js"
export * from "./PerformanceTargetResultCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports